export function validatePassword(password: string) {
  const errors = {
    tooShort: password.length < 8,
    noLower: !/[a-z]/.test(password),
    noUpper: !/[A-Z]/.test(password),
    noDigitOrSymbol: !/[0-9!@#$%^&*(),.?":{}|<>_\-+=[\]\\/~`]/.test(password),
  }

  return {
    isValid: !Object.values(errors).some(Boolean),
    errors,
  }
}

export function getPasswordValidationMessage(
  password: string
): string | null {
  const { errors } = validatePassword(password)

  if (errors.tooShort) {
    return "Password must be at least 8 characters long"
  }
  if (errors.noLower) {
    return "Password must contain at least one lowercase letter"
  }
  if (errors.noUpper) {
    return "Password must contain at least one uppercase letter"
  }
  if (errors.noDigitOrSymbol) {
    return "Password must contain at least one number or symbol"
  }

  return null
}
